import React, { useEffect, useRef, useState } from 'react';
import { isTablet } from 'react-device-detect';
import { Paper, Typography, Box, TextField, Button, List, ListItem, ListItemText, IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import CallIcon from '@mui/icons-material/Call';

// Version tablette du chat : UI simplifiée et interactions tactiles
export default function ChatTabApp() {
  // Affiche un message si non sur tablette
  if (!isTablet) return <Box p={4}><Typography variant="h6">Ce chat est réservé aux tablettes.</Typography></Box>;

  // État minimal (à adapter selon vos besoins)
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [username, setUsername] = useState(() => window.localStorage.getItem('currentUserName') || "Anonyme");
  const [users, setUsers] = useState([]);
  const [recipient, setRecipient] = useState('');
  const [showConversation, setShowConversation] = useState(false);

  // Exemples de hooks pour WebSocket, appels, etc. (à compléter)
  // ...

  return (
    <Paper elevation={4} sx={{ p: 2, maxWidth: 600, margin: 'auto', mt: 4 }}>
      <Typography variant="h5" mb={2}>Chat Tablette</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        {/* Liste des utilisateurs connectés */}
        <Box sx={{ width: 200, bgcolor: '#f3f3fa', borderRadius: 2, p: 1 }}>
          <Typography variant="subtitle2">Utilisateurs</Typography>
          <List>
            {users.map(u => (
              <ListItem
                key={u.id || u.username}
                button
                sx={{ mb: 1, borderRadius: 1 }}
                onClick={() => {
                  setRecipient(u.username || u.id);
                  setShowConversation(true);
                }}
                onTouchEnd={() => {
                  setRecipient(u.username || u.id);
                  setShowConversation(true);
                }}
              >
                <ListItemText primary={u.username || u.id} />
                <IconButton size="small" sx={{ ml: 1 }}><CallIcon fontSize="small" /></IconButton>
                <IconButton size="small"><VideocamIcon fontSize="small" /></IconButton>
              </ListItem>
            ))}
          </List>
        </Box>
        {/* Fenêtre de conversation */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {showConversation && recipient ? (
            <>
              <Typography variant="h6" color="primary">Chat avec {recipient}</Typography>
              <Box sx={{ flex: 1, overflowY: 'auto', my: 2, minHeight: 200, bgcolor: '#fff' }}>
                {/* Affichage des messages (à compléter) */}
                {messages.filter(m => m.sender === recipient || m.recipient === recipient).map((msg, idx) => (
                  <Box key={idx} sx={{ mb: 1, p: 1, borderRadius: 1, bgcolor: msg.sender === username ? '#e3f3fd' : '#f5f5f5' }}>
                    <strong>{msg.sender}:</strong> {msg.content}
                  </Box>
                ))}
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Votre message..."
                  value={input}
                  fullWidth
                  onChange={e => setInput(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') {/* envoyer message */} }}
                />
                <Button variant="contained">Envoyer</Button>
              </Box>
            </>
          ) : (
            <Box sx={{ color: '#888', textAlign: 'center', mt: 4 }}>
              <Typography>Veuillez sélectionner un utilisateur.</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
}
